import React from 'react';

import { useNewsFiltersStore } from '~/views/news/stores/use-news-filters-store/useNewsFiltersStore';
import { countFilterKeyChecked } from '~/views/news/utils/news-filters-utils/news-filters-utils';

import { ClearFiltersButton } from '../clear-filters-button/ClearFiltersButton';
import { HighlightsFilters } from '../highlights-filters/HighlightsFilters';
import { NewsList } from '../news-list/NewsList';
import { SideAccordionFilters } from '../side-accordion-filters/SideAccordionFilters';
import * as S from './NewsView.styles';

export const NewsView = () => {
  const {
    filters,
    setIsMostReadSelected,
    resetAll,
    toggleFilterOption,
    isMostReadSelected,
  } = useNewsFiltersStore();

  const showResetButton =
    isMostReadSelected ||
    filters.some(
      f => countFilterKeyChecked({ filters, filterKey: f.key }).some
    );

  return (
    <S.NewsViewRoot data-testid="news-lists-container">
      <S.LeftContent>
        <NewsList />
      </S.LeftContent>
      <S.RightContent>
        <HighlightsFilters
          isFetchMostRead={isMostReadSelected}
          toggleIsFetchMostRead={setIsMostReadSelected}
        />
        <SideAccordionFilters
          filters={filters}
          toggleFilterOption={toggleFilterOption}
        />
        {showResetButton && (
          <ClearFiltersButton
            data-testid="reset-all-filters"
            onClick={resetAll}
          />
        )}
      </S.RightContent>
    </S.NewsViewRoot>
  );
};
